import { isSameDay } from 'date-fns';

import getEndOfDayDate from './getEndOfDayDate';

export default function getRangeValue({
  newlySelectedDate,
  startDate,
  endDate,
  allowSameStartAndEndDate,
}: {
  newlySelectedDate: Date;
  startDate?: Date | null;
  endDate?: Date | null;
  allowSameStartAndEndDate?: boolean;
}): { startDate?: Date | null; endDate?: Date | null } {
  if (startDate && endDate) {
    return { startDate: newlySelectedDate, endDate: null };
  } else if (!startDate) {
    return { startDate: newlySelectedDate, endDate: null };
  } else if (startDate > newlySelectedDate) {
    const newEndDate = getEndOfDayDate(startDate);

    return { startDate: newlySelectedDate, endDate: newEndDate };
  } else if (isSameDay(startDate, newlySelectedDate)) {
    if (allowSameStartAndEndDate) {
      const newEndDate = getEndOfDayDate(newlySelectedDate);

      return { startDate, endDate: newEndDate };
    } else {
      return { startDate: newlySelectedDate, endDate: null };
    }
  } else {
    const newEndDate = getEndOfDayDate(newlySelectedDate);
    return { startDate, endDate: newEndDate };
  }
}
